import {
	CLOSE_ALERT_FAIL,
	CLOSE_ALERT_SUCCESS,
	SET_ALERT_FAIL,
	SET_ALERT_SUCCESS,
} from './types';

const initialState = {
	alertType: '',
	alertMessage: '',
	status: false,
	loading: true,
};

export default function (state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case SET_ALERT_SUCCESS:
			return {
				...state,
				alertType: payload.alertType,
				alertMessage: payload.message,
				status: payload.status,
				loading: false,
			};
		case CLOSE_ALERT_SUCCESS:
		case SET_ALERT_FAIL:
		case CLOSE_ALERT_FAIL:
			return {
				...state,
				alertType: '',
				alertMessage: '',
				status: false,
				loading: false,
			};

		default:
			return state;
	}
}
